import { IconButton, Text, HStack } from '@genial/components';
import { Color, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface HeaderProps {
  onClose: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onClose }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Text color="neutral.black" fontSize={Typography['fontsize.lg']} variant="semibold">
        Deseja cancelar esta ordem?
      </Text>
      <IconButton
        testId="icon-close"
        icon="Close"
        iconSize="xxxs"
        p={0}
        backgroundColor="transparent"
        iconColor={Color['brand.primary.principal']}
        borderColor={Color['brand.primary.principal']}
        onPress={onClose}
        {...(!isMobile && {
          iconSize: 'xs',
          icon: 'CloseModal',
          variant: 'rounded',
          borderWidth: 0.05,
        })}
      />
    </HStack>
  );
};
